import { RestEndpoint, RestGenerics } from "@rest-hooks/rest/next";
import { Auth } from "aws-amplify";
import { mockAuth } from "./MockAuth";

export default class AuthdEndpoint<
  O extends RestGenerics = any
> extends RestEndpoint<O> {
  async getHeaders(headers: HeadersInit) {
    const useMockAuth =
      process.env.REACT_APP_USE_MOCK_AUTH === "true" &&
      process.env.NODE_ENV === "development";
    const authService = useMockAuth ? mockAuth : Auth;

    const token = (await authService.currentSession()).getIdToken().getJwtToken();

    return {
      ...headers,
      Authorization: token,
    };
  }
}
